import React, { useEffect, useState } from 'react';
import { Fab } from '@material-ui/core';
import ArrowUpIcon from '@material-ui/icons/ArrowUpward';
import './ScrollToTopButton.css';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    background: 'black',
    color: 'white',
  },
});

const ScrollToTopButton = () => {
  const classes = useStyles();

  const [showScroll, setShowScroll] = useState(false);

  const getShouldShowButton = () => {
    window.pageYOffset > 500 ? setShowScroll(true) : setShowScroll(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', getShouldShowButton);
    return () => {
      window.removeEventListener('scroll', getShouldShowButton);
    };
  }, []);

  return (
    <div className="scroll-to-top" onClick={scrollToTop}>
      {showScroll && (
        <div>
          <Fab className={classes.root} color="default">
            <ArrowUpIcon fontSize="large" />
          </Fab>
        </div>
      )}
    </div>
  );
};

export default ScrollToTopButton;
